import { render, staticRenderFns } from "./channelManager.vue?vue&type=template&id=64d82cb5"
import script from "./channelManager.vue?vue&type=script&lang=js"
export * from "./channelManager.vue?vue&type=script&lang=js"
import style0 from "./channelManager.vue?vue&type=style&index=0&id=64d82cb5&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports